import styled from 'styled-components'

import Button from '../../atoms/Button/Button'

const MobileFixed = styled.div`
  position: fixed;
  z-index: 1010;
  top: 64px;
  right: 0;
  padding: ${props => props.theme.gutter}px;
  display: flex;
  flex-direction: row;

  @media (max-width: 767.9px) {
    ${Button} {
      background-color: ${props => props.theme.colors.white};
      color: ${props => props.theme.colors.gray600};
      border-color: ${props => props.theme.colors.gray600};
    }
  }

  ${Button} + ${Button} {
    margin-left: ${props => props.theme.gutter}px;
  }

  @media (min-width: 768px) {
    position: relative;
    top: 0;
    padding: 0 0 0 ${props => props.theme.gutter}px;
  }
`

export default MobileFixed
